var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOranWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 38,
    viewBox: "0 0 259 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 29.0479L138.072 16.0361L138.94 13L145.879 29.0479H132Z",
    fill: "#CF1463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 13H106V25H92V13Z",
    fill: "#CF1463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99 29C96.2292 29 93.8646 28.0312 91.9062 26.0938C89.9688 24.1354 89 21.7708 89 19C89 16.2292 89.9688 13.875 91.9062 11.9375C93.8646 9.97917 96.2292 9 99 9C101.771 9 104.125 9.97917 106.062 11.9375C108.021 13.875 109 16.2292 109 19C109 21.7708 108.021 24.1354 106.062 26.0938C104.125 28.0312 101.771 29 99 29ZM99 25C100.667 25 102.083 24.4167 103.25 23.25C104.417 22.0833 105 20.6667 105 19C105 17.3333 104.417 15.9167 103.25 14.75C102.083 13.5833 100.667 13 99 13C97.3333 13 95.9167 13.5833 94.75 14.75C93.5833 15.9167 93 17.3333 93 19C93 20.6667 93.5833 22.0833 94.75 23.25C95.9167 24.4167 97.3333 25 99 25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.906 29L118.312 17H125.312C125.875 17 126.344 16.8125 126.719 16.4375C127.115 16.0417 127.312 15.5625 127.312 15C127.312 14.4375 127.115 13.9688 126.719 13.5938C126.344 13.1979 125.875 13 125.312 13H115.312V29H111.312V9H125.312C126.979 9 128.396 9.58333 129.562 10.75C130.729 11.9167 131.312 13.3333 131.312 15C131.312 16.6667 130.729 18.0833 129.562 19.25C128.396 20.4167 126.979 21 125.312 21H124.438L128.875 29H124.906Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.594 29L139.594 8L149.594 29H145.094L139.594 17.5L134.094 29H129.594Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.594 15V29H150.594V9H154.594L166.594 23V9H170.594V29H166.594L154.594 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOranWhite);
export default __webpack_public_path__ + "static/media/Oran_white.74d83199b714cb5a1970baba749f68c7.svg";
export { ForwardRef as ReactComponent };